import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MainContainer = styled.div`
  padding: 0px 0px 16px 0px;
`;

const Container = styled.div`
  padding-left: 16px;
  border-left: 1px solid ${props => props.theme.blueGray};
  display: flex;
`;

const TextBox = styled.textarea`
  border: 1px solid ${props => props.theme.blueGray};
  box-sizing: border-box;
  border-radius: 6px;  
  padding: 8px 16px !important;
  resize: none;
  outline: none;
  flex: 1;
  min-height: 72px;
  &::placeholder {
    color: ${props => props.theme.blueGray};
    opacity: 1; /* Firefox */
  }
`;

const ButtonsContainer = styled.div`
  min-width: 118px;
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 700px) {
    min-width: 72px;
  }
`;

const SubmitButton = styled.button`
  color: ${props => props.theme.white};
  outline: none;
  background-color: ${props => props.theme.blue};
  border: none;
  display: block;
  width: 100%;
  box-sizing: border-box;
  border-radius: 6px;
  height: 32px;
  cursor: pointer;
`;

const CancelButton = styled.button`
  color: ${props => props.theme.darkBlue};
  outline: none;
  background-color: ${props => props.theme.white};
  border: 1px solid ${props => props.theme.blueGray};
  display: block;
  width: 100%;
  box-sizing: border-box;
  border-radius: 6px;
  height: 32px;
  cursor: pointer;
`;

class ReplyInput extends Component {
  state = {
    text: ''
  };

  changeText = text => {
    this.setState({ text });
  }

  handleSubmit = e => {
    e.preventDefault();
    if (this.state.text.length > 0) {
      this.props.handleReply(this.state.text);
    }
  }

  render() {
    const { text } = this.state;
    return (
      <MainContainer>
        <form onSubmit={this.handleSubmit}>
          <Container>
            <TextBox value={text} onChange={e => this.changeText(e.target.value)} placeholder="Add a reply" />
            <ButtonsContainer>
              <SubmitButton type="submit">Reply</SubmitButton>
              <CancelButton onClick={this.props.cancelReply}>Cancel</CancelButton>
            </ButtonsContainer>
          </Container>
        </form>
      </MainContainer>
    );
  }
}

ReplyInput.propTypes = {
  handleReply: PropTypes.func,
  cancelReply: PropTypes.func,
};

export default ReplyInput;
